module.exports = __webpack_public_path__ + "img/download-audio-light-ok.d07710cc.png";